import { TOOLBAR_BUTTON_SX } from "@/controls/buttons/toolbarButton";
import { ResetFiltersButton } from "@/controls/buttons/ResetFiltersButton";
import { Box, Button, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { StandSelector } from "@/shared/selectors/StandSelector";
import { PassTypeSelector } from "./PassTypeSelector";
import { PassShapeSelector } from "./PassShapeSelector";
import { ShowOnlyActivesCheckbox } from "@/controls/filters/ShowOnlyActivesCheckbox";

interface PassIdsToolbarProps {
	search: string;
	onSearchChange: (value: string) => void;
	standId: number | null;
	onStandChange: (value: number | null) => void;
	passTypeId: number | null;
	onPassTypeChange: (value: number | null) => void;
	passShapeId: number | null;
	onPassShapeChange: (value: number | null) => void;
	onlyActives: boolean;
	onOnlyActivesChange: (value: boolean) => void;
	onAdd: () => void;
	onReset: () => void;
	canReset: boolean;
}

export const PassIdsToolbar = ({
	search,
	onSearchChange,
	standId,
	onStandChange,
	passTypeId,
	onPassTypeChange,
	passShapeId,
	onPassShapeChange,
	onlyActives,
	onOnlyActivesChange,
	onAdd,
	onReset,
	canReset,
}: PassIdsToolbarProps) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 1,
				flexWrap: "wrap",
				px: 1.5,
				py: 0.75,
			}}
		>
			<TextField
				size="small"
				placeholder="Search..."
				value={search}
				onChange={(e) => onSearchChange(e.target.value)}
				sx={{ width: 200 }}
			/>

			<StandSelector
				includeStraighteners
				value={standId}
				onChange={onStandChange}
				includeAll
				sx={{ width: 130 }}
			/>
			<PassTypeSelector
				value={passTypeId}
				onChange={onPassTypeChange}
				includeAll
				sx={{ width: 180 }}
			/>
			<PassShapeSelector
				value={passShapeId}
				onChange={onPassShapeChange}
				includeAll
				sx={{ width: 180 }}
			/>

			<ShowOnlyActivesCheckbox
				checked={onlyActives}
				onChange={onOnlyActivesChange}
			/>

			<ResetFiltersButton onClick={onReset} disabled={!canReset} />

			<Box sx={{ flex: 1 }} />

			<Button
				variant="contained"
				color="primary"
				startIcon={<AddIcon />}
				onClick={onAdd}
				size="medium"
				sx={TOOLBAR_BUTTON_SX}
			>
				Add Pass ID
			</Button>
		</Box>
	);
};
